<section-title [icon]="'history'" [text]="'Transactions History'"></section-title>
<fieldset>
    <legend>Filter</legend>

    <div class="filter-row">
        <span class="filter-date">
            <mat-form-field appearance="fill">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="Start date" [(ngModel)]="filter.startDate" (dateChange)="dateChanged()" readonly>
                <input matEndDate placeholder="End date" [(ngModel)]="filter.endDate" (dateChange)="dateChanged()" readonly>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </span>

        <span class="filter-recipient">
            <mat-form-field appearance="fill">
                <mat-label>Recipient</mat-label>
                <input matInput [(ngModel)]="filter.recipient">
            </mat-form-field>
        </span>

        <span class="filter-sender">
            <mat-form-field appearance="fill">
                <mat-label>Sender</mat-label>
                <input matInput [(ngModel)]="filter.sender">
            </mat-form-field>
        </span>

        <span class="filter-direction">
            <mat-form-field appearance="fill">
                <mat-label>Direction</mat-label>
                <mat-select [(ngModel)]="filter.direction">
                    <mat-option *ngFor="let field of filterDirections" [value]="field.id">{{field.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </span>

        <span class="filter-payment-method">
            <mat-form-field appearance="fill">
                <mat-label>Payment Method</mat-label>
                <mat-select [(ngModel)]="filter.paymentMethod">
                    <mat-option *ngFor="let field of filterPaymentMethods" [value]="field.id">{{field.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </span>

        <span class="filter-field">
            <mat-form-field appearance="fill">
                <mat-label>Search by</mat-label>
                <mat-select [(ngModel)]="filter.field">
                    <mat-option *ngFor="let field of filterFields" [value]="field.id">{{field.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </span>

        <mat-form-field class="search-field" appearance="fill">
            <mat-label>Search for transactions</mat-label>
            <input matInput [(ngModel)]="filter.value">
            <button matSuffix mat-icon-button [disabled]="!filter.value" (click)="filter.value = ''">
                <mat-icon>clear</mat-icon>
            </button>
            <button matSuffix mat-icon-button [disabled]="!searchAllowed" (click)="search()">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
    </div>

    <filter-periods (init)="initFilter($event)" (periodChange)="periodChange($event)"></filter-periods>

</fieldset>

<button mat-icon-button color="primary" title="Export to Excel" [disabled]="!searchAllowed || empty(transactions.entities)" (click)="export()">
    <mat-icon>cloud_download</mat-icon> Export to Excel
</button>

<table mat-table [dataSource]="transactions.entities">

    <!-- 3DS Indecate Column -->
    <ng-container matColumnDef="3ds">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" (click)="view(element)">
            <span [ngClass]="element.threeDs ? 'green-circle' : 'red-circle'"></span>
        </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="transactionDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : ''">
            {{element.transactionDate | localTime}}
        </td>
    </ng-container>

    <!-- Transaction ID Column -->
    <ng-container matColumnDef="transactionId">
        <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : ''">
            {{element.transactionId}}
        </td>
    </ng-container>

    <!-- Recipient Column -->
    <ng-container matColumnDef="recipient">
        <th mat-header-cell *matHeaderCellDef>Recipient</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : ''">
            {{element.recipientName}}
        </td>
    </ng-container>

    <!-- Sender Column -->
    <ng-container matColumnDef="sender">
        <th mat-header-cell *matHeaderCellDef>Sender</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : ''">
            {{element.senderName}}
        </td>
    </ng-container>

    <!-- Payer Column -->
    <ng-container matColumnDef="payer">
        <th mat-header-cell *matHeaderCellDef>Payer</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : ''">
            <div>{{element.payerName}}</div>
            <div>{{element.payerEmail}}</div>
            <div *ngIf="element.paymentMethodId == paymentMethod.creditCard && element.ccNumber">Card Num: {{element.ccNumber}}</div>
        </td>
    </ng-container>

    <!-- Amount Column -->
    <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : 'positive-amount'">
            {{element.unit}} {{element.grossAmount | number:'1.0-2'}}
        </td>
    </ng-container>

    <!-- Payment Method Column -->
    <ng-container matColumnDef="paymentMethod">
        <th mat-header-cell *matHeaderCellDef>Payment Method</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : ''">
            {{paymentMethodService.nameof(element.paymentMethodId)}}
        </td>
    </ng-container>

    <!-- 3DS Column -->
    <ng-container matColumnDef="threeDs">
        <th mat-header-cell *matHeaderCellDef>3DS</th>
        <td mat-cell *matCellDef="let element" (click)="view(element)" [ngClass]="element.grossAmount < 0 ? 'negative-amount' : ''">
            {{element.threeDs ? 'Yes' : 'No'}}
        </td>
    </ng-container>

    <!-- Action Column -->
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <span *ngIf="element.chargedBack" title="Charged back" class="warning">
                <mat-icon>warning</mat-icon>
            </span>
            <button mat-icon-button title="Transaction details" (click)="view(element)">
                <mat-icon>visibility</mat-icon>
            </button>
        </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<div *ngIf="empty(transactions.entities)" class="no-data"><mat-icon>search</mat-icon>No transactions by search criteria</div>
<div class="pagination">
    <pagination [pagination]="pagination" (pageChange)="pageChanged($event)"></pagination>
</div>
